// extracted by mini-css-extract-plugin
export default {"refreshButton":"App_refreshButton__sCnTT","refreshButtonChat":"App_refreshButtonChat__Styke"};